// store/modules/image-product-task.ts
import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface ImageProductTaskState extends ListState<any> {
}

class ImageProductTaskMutations extends ListMutations<any> {
}

class ImageProductTaskModule extends ListModule<ImageProductTaskState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array < any > (),
        loading: false
    }

    actions = {
        // ��ȡ�����б�
        async getTaskList(context: ActionContext<ImageProductTaskState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/ImageProduct/GetTaskList', { params: payload.data });
            context.state.loading = false;
            const page = response.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        // ��������
        async importTasks(context: ActionContext<ImageProductTaskState, any>, payload: any) {
            const formData = new FormData();
            formData.append('file', payload.file);
            formData.append('batchName', payload.batchName);

            await Ajax.post('/api/services/app/ImageProduct/ImportTasks', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    };

    mutations = {
        setCurrentPage(state: ImageProductTaskState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ImageProductTaskState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const imageProductTask = new ImageProductTaskModule();
export default imageProductTask;